import ReactGA from 'react-ga4';
import { useState } from "react";
import { Header } from "../components/Header";
import { ReactComponent as Logo } from "../../../assets/icons/Logo.svg";
import { ProgressStep } from "./ProgressStep";
import { Step1 } from "./Step1";
import { QuizCreatePartialSignup, } from "./QuizCreatePartialSignup";
import { OutOfStateWaitlist } from "./OutOfStateWaitlist";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { zipCodes } from "../../../assets/data/zip_codes";

export enum AutismChallenge {
  COMMUNICATION = "COMMUNICATION",
  SOCIAL_SKILLS = "SOCIAL_SKILLS",
  BEHAVIOR_CHALLENGES = "BEHAVIOR_CHALLENGES",
  DAILY_LIVING_SKILLS = "DAILY_LIVING_SKILLS",
  SCHOOL_READINESS = "SCHOOL_READINESS",
  OTHER = "OTHER",
}

export type ClientQuizFormType = {
  zipCode?: string;
  autismDiagnosis?: 'YES' | 'NO' | 'IN_PROCESS';
  challenges?: AutismChallenge[];
  insuranceProvider?: string;
  otherInsuranceProvider?: string;
}

export function ClientQuiz() {
  const [step, setStep] = useState(1);
  const [started, setStarted] = useState(false);

  const [clientQuizForm, setClientQuizForm] = useState<ClientQuizFormType>({
    zipCode: "",
    autismDiagnosis: undefined,
    challenges: [],
    insuranceProvider: undefined,
    otherInsuranceProvider: "",
  });

  const handleNext = () => {
    if (process.env.REACT_APP_ENV === "prod" && step <= 4) {
      ReactGA.event(`quiz-completed-step-${step}`)
    }
    if (step === 1) {
      if (!started && process.env.REACT_APP_ENV === "prod") {
        ReactGA.event("quiz-started")
      }
      setStarted(true);
    }
    if (step === 3) {
      const state = clientQuizForm.zipCode && zipCodes[clientQuizForm.zipCode]?.state
      if (!state || !["Indiana", "Georgia", "North Carolina"].includes(state)) {
        setStep(6);
        return;
      }
    }
    setStep((prev) => prev + 1);
  }

  return (
    <div
      className="h-screen bg-secondary overflow-auto"
      style={{ backgroundImage: "url('/images/authpage-overlay.png')" }}
    >
      {/* <Header showSignIn /> */}
      <div className="py-10 px-4 md:px-0">
        <div className="flex justify-center items-center">
          <div className={step >= 5 ? "max-w-[820px] lg:max-w-[1000px]" : "max-w-[820px] lg:w-[63vw]"}>
            <div className="justify-center items-center flex mb-8">
              <Logo />
            </div>
            {step <= 4 && (
              <ProgressStep
                currentStep={step}
              />
            )}
            {step === 1 && (
              <Step1
                onNext={handleNext}
                clientQuizForm={clientQuizForm}
                setClientQuizForm={setClientQuizForm}
              />
            )}
            {step === 2 && (
              <Step2
                onNext={handleNext}
                clientQuizForm={clientQuizForm}
                setClientQuizForm={setClientQuizForm}
              />
            )}
            {step === 3 && (
              <Step3
                onNext={handleNext}
                clientQuizForm={clientQuizForm}
                setClientQuizForm={setClientQuizForm}
              />
            )}
            {step === 4 && (
              <Step4
                onNext={handleNext}
                clientQuizForm={clientQuizForm}
                setClientQuizForm={setClientQuizForm}
              />
            )}
            {step === 5 && (
              <QuizCreatePartialSignup
                clientQuizForm={clientQuizForm}
              />
            )}
            {step === 6 && (
              <OutOfStateWaitlist
                clientQuizForm={clientQuizForm}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
